//NPM
import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import {filter, find, forEach, isEmpty, isNil, map} from 'lodash';
import nextbillion, { NBMap, Marker, Popup } from '@nbai/nbmap-gl'

// ANTD
import { Col, Row, Checkbox } from "antd";
import type { CheckboxChangeEvent } from "antd/es/checkbox";

// SHARED COMPONENTS
import { Button, Tabs, TextInput } from "@life-line-lab/components-react";

// STYLESHEETS
import "./control-tower.scss";

interface ControlTowerDashboardProps {
  servicePointDatas?: Array<any>,
  servicePointTypes?: Array<any>,

}

const ControlTowerAllView: React.FC<ControlTowerDashboardProps> = ({
  servicePointDatas,
  servicePointTypes
}) => {
  const { t } = useTranslation();
  const history = useHistory();
  const CheckboxGroup = Checkbox.Group;

  const [checkedList, setCheckedList] = useState([])
  const [checkAll, setCheckAll] = useState(false);
  const [indeterminate, setIndeterminate] = useState(true);
  const [points, setPoints] = useState({})

  useEffect(() => {
    nextbillion.setApiKey(`${process.env.NEXT_BILLION_KEY}`)

    const nbmap = new NBMap({
      container: 'map',
      style: 'https://api.nextbillion.io/maps/streets/style.json',
      zoom: 8,
      center: { lat: 3.164005474252092, lng: 101.65040013068355 }
    })

    let filteredServicePoints = filterData();

    map(filteredServicePoints, tsk=>{
        if(!isNil(tsk?.coordinate)){
          return addSimpleMarker(nbmap, tsk?.coordinate?.lat , tsk?.coordinate?.lon, tsk.locationName)
        }
    })

  }, [checkedList])

  const checkBoxChange = (e) => {
    const type: any = e.target.name;
    const isChecked: Boolean = e.target.checked;
    if(!isChecked){
      let filteredCheckList = filter(checkedList, checkStr => {
        return checkStr != type;
      })
      setCheckedList(filteredCheckList);
    }else{
      setCheckedList( [
        ...checkedList,
        type,
      ]);
    }
  };

  const onAllCheckboxChange = (e: CheckboxChangeEvent) => {
    setIndeterminate(!indeterminate)
  };

  const filterData = () => {
    // create a copy of the original data to avoid mutating it

    let filteredData = [];

    if(isEmpty(checkedList)){
      return servicePointDatas
    }

    forEach(servicePointDatas, servicePointObj => {
      servicePointObj.servicePointType.forEach((item) => {
        if(checkedList.includes(item)){
          filteredData.push(servicePointObj)
        }
      })
    })

    // filter the data based on the selected checkboxes
    // filteredData.forEach((item) => {
    //   item.servicePointType = item.servicePointType.filter((type) =>
    //     checkedList.includes(type)
    //   );
    // });

    // return the filtered data
    return filteredData;
  }


  const addSimpleMarker = (nbmap, lat, long, markerName) => {
    const popup = new Popup({ offset: 25, closeButton: false }).setText(
      markerName
    )
    if(lat < -180 || lat > 180 || long < -90 || lat > 90){
      return;
    }
    const marker = new Marker()
      .setLngLat({ lat: lat, lng: long })
      .setPopup(popup)
      .addTo(nbmap.map)
    marker.togglePopup()
  }

  return (
    <div>
      <div className="control-tower">
        <Row>
          <Col xs={24} sm={24} md={18} xl={16} xxl={18}>
            {/*<img src="/assets/images/map-placeholder.png" className="map-placeholder"></img>*/}
            <div
              style={{
                width: '100%',
                minHeight: '500px',
                height: 'auto'
              }}
              id="map"></div>
          </Col>
          <Col xs={24} sm={24} md={6}  xl={8} xxl={6} className="task-menu">
            <h2>Show</h2>
            <div className="right-bar">
              <div>
                <Checkbox
                  disabled={false}
                  indeterminate={true}
                  onChange={onAllCheckboxChange}
                  checked={true}>
                  <div style={{ position: "relative" }}>
                    <p>All</p>
                  </div>
                </Checkbox>
              </div>
              <div>
              {map(servicePointTypes, (type) => {
                return (
                  <>
                    <Checkbox
                      disabled={false}
                      checked={checkedList.includes(type.name)}
                      name={type.name}
                      onChange={(e)=>{checkBoxChange(e, type.name)}}
                    >
                      <div style={{ position: "relative" }}>
                        <div className="checkbox-marker" style={{ background: "#E8A51A" }} />
                        <p style={{ marginLeft: "15px" }}>{type.name}</p>
                      </div>
                    </Checkbox>
                    <br />
                  </>
                )
              }
              )}


            </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ControlTowerAllView;
